import { render, staticRenderFns } from "./AppointmentsNav.vue?vue&type=template&id=168c9276"
import script from "./AppointmentsNav.vue?vue&type=script&lang=js"
export * from "./AppointmentsNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports